import { Box } from '@mui/material'
import { DynamicForm as FormsIcon } from '@mui/icons-material'
import { PageHeader } from '../components/shared/PageHeader'
import { LeadFormsList } from '../features/leadforms/LeadFormsList'

export default function LeadFormsPage() {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <PageHeader
        title="Lead Forms"
        subtitle="Create shareable forms that capture leads automatically"
      />
      <LeadFormsList />
    </Box>
  )
}
